import { TraceXInterceptor } from '@trace-x/trace-x-generator';
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {
  CALENDAR_VIEW,
  ConfigService,
  DataShareService,
  DestinationType,
  FetchCriteriaDataExchangeModel,
  GENERAL_SEPARATORS,
  KeyCodes,
  OntologyResponse,
  ProductType,
  SPLITTER,
  StringConcatenationClass,
  SurfAuthorizationService,
  SurfCalendarStartDateService,
  SurfCityPipe,
  SurfCriteriaUtil,
  SurfErrorMessages,
  SurfScrollDirective,
  SurfStaticDataService,
  SurfTextCasePipe,
  SurfTourUtilService,
  SurfTravellerEarliestDepartureDateService,
  SurfUtilService,
  SurfVisibilityConfigService,
  TourCriteria
} from '@surf/surf-components-core';
import {MultiFieldInputData, MultiFieldInputPropertyFactory} from '@surf/surf-multi-field-input';
import {PaxAllocationItem} from '@surf/surf-pax-selection';
import {NameCodePair} from '@tc-core/model/it/codegen/tbx/api/v2/commons/name-code-pair';
import {DataServiceHandler} from '@tc-core/service/service-handlers';
import {TC} from '@tc-core/util';
import {ConfigLoader, DataKey, DataStore} from '@tc-core/util/framework';
import {Subscription} from 'rxjs';
import {PermissionKeys} from '../security/permission-constants';
import surfOperations from '../security/tour-criteria-operations.json';

@Component({
  selector: 'surf-tour-criteria',
  templateUrl: './tour-criteria.component.html'
})
export class TourCriteriaComponent implements OnInit, OnChanges {

  constructor(
    protected commonService: DataShareService,
    protected dataServiceHandler: DataServiceHandler,
    protected surfStaticDataService: SurfStaticDataService,
    protected configService: ConfigService,
    protected surfUtilService: SurfUtilService,
    public surfCriteriaUtil: SurfCriteriaUtil,
    protected configLoader: ConfigLoader,
    protected surfCalendarStartDateService: SurfCalendarStartDateService,
    protected surfTourUtilService: SurfTourUtilService,
    protected dataStore: DataStore,
    protected surfAuthorizationService: SurfAuthorizationService,
    protected travellerEarliestDepartureDateService: SurfTravellerEarliestDepartureDateService,
    protected surfVisibilityConfigService: SurfVisibilityConfigService
  ) {
    this.cityPipe = new SurfCityPipe(surfStaticDataService);
  }

  @Input() isDPSearch = false;
  @Input() index: number;
  @Input() unfreeze = true;
  @Input() isServiceAddComponent = false;
  @Input() isRefine = false;
  @Input() setRoomWise = false;
  @Input() windowScrollEnable = true;
  @Input() selectedPax: any;
  @Input() cartPaxSelection: any;
  @Input() isAmendmentFlow = false;
  @Input() isItemCloseable = true;
  @Input() triggerExternalSearch = '';
  @Input() isDisableGrabTourButton = false;
  @Input() keyControls;
  @Input() isDpGrab = false;
  @Input() grabBlockDetails: NameCodePair ;
  @Input() grabbedTourDetailList: FetchCriteriaDataExchangeModel[];
  @Input() dpTourRefineCriteria: any;
  @Output() cancelRefine: EventEmitter<any> = new EventEmitter<any>();
  @Output() itemRemoved: EventEmitter<any> = new EventEmitter<any>();
  @Output() isValid = new EventEmitter<boolean>();
  @Output() getUrlCriteria: EventEmitter<any> = new EventEmitter();
  @Output() getCurrentTourCriteria = new EventEmitter<TourCriteria>();
  @Output() isUnfreeze = new EventEmitter<boolean>();
  displayingGrabbedTourDetailList: FetchCriteriaDataExchangeModel[];

  /**
   * variables
   */
  paxDisplay: string;
  subscription = new Subscription();
  tourCriteria: TourCriteria = new TourCriteria();
  guestComponentFocus = false;
  currentPaxOption = 0;
  enterPressed = false;
  defaultPaxSet: Array<PaxAllocationItem> = [];
  TEEN_PAX_ACTIVE = true;
  DISABLE_DP_SWITCH = false;
  keyParams: string;
  destinationList = [];
  tourSuppliers = [];
  guideLanguages = [];
  flexibleOnDates = [];
  isRefineSupplier = false;
  initialDates = [];
  resetCalendar = false;
  defaultActiveCalendar = CALENDAR_VIEW.SINGLE_YEAR_VIEW;

  isDateNotSelected = false;
  durationError = false;
  durationProperty;
  durationValues;
  msg = '';
  selectedStop: OntologyResponse = new OntologyResponse();
  selectedDestination: OntologyResponse = new OntologyResponse();
  selectedTourName: OntologyResponse = new OntologyResponse();
  selectedTourCategory: OntologyResponse = new OntologyResponse();

  tourStopCityURL = '';
  destinationCityURL = '';
  tourNameURL = '';
  destinationCategoryURL = '';
  filteredTourStop = [];
  filteredDestinationCity = [];
  filteredTourName = [];
  filteredTourCategory = [];
  destNames;

  MIN_SEARCH_QUERY_LENGTH = 3;
  TOU_SEARCH_RESULT_COUNT = 200;
  stopSearchInitialized = false;
  destSearchInitiated = false;
  nameSearchInitialized = false;
  categorySearchInitialized = false;
  cityPipe: SurfCityPipe;

  depPortPartiallyTyped = false;
  initialCategory = 'Any supplier';
  initialGuideLanguage = '';
  initialFlexibleOnDate = 0;
  readonly NONE_SELECTED = '-1';
  FIELD_SEPERATOR = GENERAL_SEPARATORS.FIELD_SEPARATOR;
  AGE_SEPERATOR = '__';
  LESS_THAN_ONE = '< 1';
  DEFAULT_ADULT_AGE = 30;
  MAX_INFANT_AGE = 23;
  MAX_CHILD_AGE = 12;
  MAX_TEEN_AGE = 17;
  TOU_MAX_CABIN_PAX_COUNT = 20;
  TOU_MAX_CHILD = this.TOU_MAX_CABIN_PAX_COUNT - 1;
  TOU_MAX_TEEN = this.TOU_MAX_CABIN_PAX_COUNT - 1;
  TOU_MAX_INFANTS = this.TOU_MAX_CABIN_PAX_COUNT - 1;
  TOU_MIN_ADULT = 1;
  TOU_MAX_ADULT = 20;
  TOU_MAX_PAX_COUNT = 40;
  visibilityConfig = {};
  calendarRange = 2;
  calendarView = CALENDAR_VIEW.SINGLE_DATE_VIEW;
  monthCalendarLabel = 'Travel Date*';
  monthCalendarPlaceholder = 'DD/MM/YYYY';
  calendarMinDate = new Date();
  DURATION_CATEGORIES = {code: 'D', value: 'Days', selected: true};
  STATIC_DATA_URL_BASE = '/data/data-service/v2/static-data';
  STATIC_DATA_FETCH_SIZE = 20;
  TOUR_STOP_SELECT_MAX = 5;
  TOUR_CATEGORY_SELECT_MAX = 5;
  SURF_ERROR_MESSAGES = SurfErrorMessages;
  stopOntologies: OntologyResponse[] = [];
  categoryOntologies: OntologyResponse[] = [];
  h2hSystemIds = 'TBX';
  moduleConfigs;
  OPERATOR = 'OPERATOR';
  SUPPLIER_LOAD = 'SUP_LOAD';
  H2H_SYSTEMS_LOAD = 'H2H_LOAD';

  grabbedTourId;
  isGrabbed = false;
  supplierSubscription;
  enableSearchFlow = true;
  permissionKeys;
  freeze: boolean;

  hideErrorMsg = true;
  validateDisabledDateSelection = false;
  advanceSearchFieldEnabled = false;
  showAdvancedSearch = false;
  ENABLED_EXTENDED_TOUR_SEARCH_CRITERIA = false;
  EXTENDED_TOUR_SEARCH_CRITERIA_MIN_NO_OF_ELEMENTS = 3;

  enableInfantAgeSelection = false;
  categoryPlaceholderText = 'Search and select multiple categories';
  tourStopPlaceholderText = 'Search and select multiple cities';
  tourNamePlaceholderText = 'Search tour name';
  departureCityPlaceholderText = 'Search city';
  ENABLE_B2B_SEARCH:boolean=true;


  ngOnInit() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.ngOnInit');
    this.loadConfigs();
    this.loadVisibilityConfigurations();
    this.doInitialSetup();
    if (this.isRefine) {
      this.setRefineDate();
    }
    this.setAuthenticationParameters();
    this.surfCalendarStartDateService.updateMinDate(this.calendarMinDate, 'TOU');
  }

  ngOnChanges(changes: SimpleChanges) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.ngOnChanges');
    if (changes.unfreeze && this.unfreeze !== undefined) {
      this.freeze = !this.unfreeze;
    }
    if (changes.selectedPax) {
      this.selectedPax = changes.selectedPax.currentValue;
      if (this.isRefine) {
        this.defaultPaxSet = this.selectedPax;
      }
      if (this.isServiceAddComponent) {
        const adults = this.selectedPax.reduce( (acc, pax ) => acc + pax.adult , 0 ) ;
        const child = this.selectedPax.reduce( (acc, pax) => acc + pax.child.length , 0) ;
        const teen = this.selectedPax.reduce( (acc, pax) => acc + pax.teen.length , 0) ;
        const infant = this.selectedPax.reduce( (acc, pax) => acc + pax.infant.length , 0 ) ;
        this.paxDisplay = this.generateDisplayString(adults, child, infant, teen) ;
      }
    }
    if (changes.cartPaxSelection && this.cartPaxSelection) {
      const adults = this.cartPaxSelection.reduce( (acc, pax ) => acc + pax.adult , 0 );
      const child = this.cartPaxSelection.reduce( (acc, pax) => acc + pax.child.length , 0);
      const teen = this.cartPaxSelection.reduce( (acc, pax) => acc + pax.teen.length , 0) ;
      const infant = this.cartPaxSelection.reduce( (acc, pax) => acc + pax.infant.length , 0 );
      this.paxDisplay = this.generateDisplayString(adults, child, infant, teen);
      this.getPassengerSelection(this.cartPaxSelection);
    }
    if (changes.triggerExternalSearch && this.triggerExternalSearch && this.triggerExternalSearch === ProductType.TOU) {
      this.searchTour(true);
      setTimeout(() => {
        this.triggerExternalSearch = '';
      }, 10);
    }
    if (changes.grabbedTourDetailList && this.grabbedTourDetailList) {
      this.tourGrabResultOutput(this.grabbedTourDetailList);
    }
  }

  /**
   * set Permission details
   */
  setAuthenticationParameters() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.setAuthenticationParameters');
    this.permissionKeys = PermissionKeys;
    this.surfAuthorizationService.initPermissions(surfOperations);
    const tourCriteriaEnabled = this.surfAuthorizationService
                                                .getPermissionResponse(PermissionKeys.TOUR_CRITERIA);
    this.enableSearchFlow = (tourCriteriaEnabled && tourCriteriaEnabled.allowed);
  }

  /**
   * generate the display string to show the selected pax numbers in surf-pax-selection component
   */
  generateDisplayString(adult, child, infant, teen) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.generateDisplayString');
    let str = '';
    if (adult === 1 && child === 0 && infant === 0 && teen === 0) {
      /*solo traveller*/
      str += '1 adult';
    } else if (adult > 1 && child === 0 && infant === 0 && teen === 0) {
      /*couple or pair or more than 1 adults*/
      str += adult + ' adults';
    } else {
      /*Group or family*/
      const tot = adult + child + infant + teen;
      str += tot + ' guests';
    }
    return str;
  }

  /**
   * load UI visibility configs
   */
  async loadVisibilityConfigurations() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.loadVisibilityConfigurations');
    const visibilityConfig = this.surfVisibilityConfigService.getVisibilityConfigs();

    this.visibilityConfig = visibilityConfig;

    if (visibilityConfig) {
      const shouldContainElements = [
        visibilityConfig['tour.search_tour_criteria.flexible_on_dates'],
        visibilityConfig['tour.search_tour_criteria.resort'],
        visibilityConfig['tour.search_tour_criteria.private_tour'],
        visibilityConfig['tour.search_tour_criteria.guide_language'],
        visibilityConfig['tour.search_tour_criteria.promo_code']
      ];
      const noOfVisibleElementsLength = shouldContainElements.filter(Boolean).length;

      if (
        noOfVisibleElementsLength <= this.EXTENDED_TOUR_SEARCH_CRITERIA_MIN_NO_OF_ELEMENTS
      ) {
        this.advanceSearchFieldEnabled = false;
        this.setShowAdvancedSearch(true);
      } else {
        this.advanceSearchFieldEnabled = true;
        this.setShowAdvancedSearch(false);
      }

      if (!this.isRefine) {
        this.defaultPaxSet = visibilityConfig['tour.search_tour_criteria.change_default_pax_count']
          ? [new PaxAllocationItem(1, [], [])]
          : [];
      }

      this.enableInfantAgeSelection = visibilityConfig['tour.search_tour_criteria.change_infant_age_selection'];
    }
  }

  /**
   * load module configs
   */
  loadConfigs() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.loadConfigs');
    this.STATIC_DATA_URL_BASE = this.configLoader.configurations.get(TC.CONF.CONF_ENDPOINT)[TC.ENDPOINT_ID.STATIC_DATA] ?
      this.configLoader.configurations.get(TC.CONF.CONF_ENDPOINT)[TC.ENDPOINT_ID.STATIC_DATA] : this.STATIC_DATA_URL_BASE;

    this.moduleConfigs = this.dataStore.get(DataKey.moduleConfiguration).getValue();

    this.moduleConfigs.forEach(mc => {
      switch (mc.code) {
        case 'STATIC_DATA_FETCH_SIZE':
          this.STATIC_DATA_FETCH_SIZE = +mc.name;
          break;
        case 'TEEN_PAX_ACTIVE':
          this.TEEN_PAX_ACTIVE = ((mc.name as string).toLowerCase() === 'true');
          break;
        case 'DISABLE_DP_SWITCH':
          this.DISABLE_DP_SWITCH = ((mc.name as string).toLowerCase() === 'true');
          break;
        case 'TOUR_STOP_SELECT_MAX':
          this.TOUR_STOP_SELECT_MAX = +mc.name;
          break;
        case 'TOUR_CATEGORY_SELECT_MAX':
          this.TOUR_CATEGORY_SELECT_MAX = +mc.name;
          break;
        case 'MAX_CABIN_PAX_COUNT':
          this.TOU_MAX_CABIN_PAX_COUNT = +mc.name;
          break;
        case 'MIN_ADULT':
          this.TOU_MIN_ADULT = +mc.name;
          break;
        case 'MAX_ADULT':
          this.TOU_MAX_ADULT = +mc.name;
          break;
        case 'MAX_PAX_COUNT':
          this.TOU_MAX_PAX_COUNT = mc.name;
          break;
        case 'MIN_SEARCH_QUERY_LENGTH':
          this.MIN_SEARCH_QUERY_LENGTH = +mc.name;
          break;
        case 'TOU_SEARCH_RESULT_COUNT':
          this.TOU_SEARCH_RESULT_COUNT = mc.name;
          break;
        case 'ENABLED_EXTENDED_TOUR_SEARCH_CRITERIA':
          this.ENABLED_EXTENDED_TOUR_SEARCH_CRITERIA = mc.name.toLowerCase() === 'true';
          break;
        case 'EXTENDED_TOUR_SEARCH_CRITERIA_MIN_NO_OF_ELEMENTS':
          this.EXTENDED_TOUR_SEARCH_CRITERIA_MIN_NO_OF_ELEMENTS = Number(mc.name);
      }

      if (this.ENABLED_EXTENDED_TOUR_SEARCH_CRITERIA) {
        if (mc.code === 'TOU_MAX_TEEN') {
          this.TOU_MAX_TEEN = +mc.name;
        }
        if (mc.code === 'TOU_MAX_CHILD') {
          this.TOU_MAX_CHILD = +mc.name;
        }
        if (mc.code === 'TOU_MAX_INFANTS') {
          this.TOU_MAX_INFANTS = +mc.name;
        }
      }
    });
    this.tourStopCityURL = this.STATIC_DATA_URL_BASE +
      '?dataTypes=CITY&userInput=[UI]&aggrLevel=COUNTRY&locale=en&matchType=CODE~NAME&expand=all&resultCount='
      + this.STATIC_DATA_FETCH_SIZE;
    this.destinationCityURL = this.STATIC_DATA_URL_BASE +
      '?dataTypes=CITY&userInput=[UI]&aggrLevel=COUNTRY&locale=en&matchType=CODE~NAME&expand=all&resultCount='
      + this.STATIC_DATA_FETCH_SIZE;
    this.tourNameURL = this.STATIC_DATA_URL_BASE +
      '?dataTypes=TOUR_NAME&userInput=[UI]&aggrLevel=NA&locale=en&matchType=NAME&expand=all&resultCount='
      + this.STATIC_DATA_FETCH_SIZE;
    this.destinationCategoryURL = this.STATIC_DATA_URL_BASE +
      '?dataTypes=TOUR_CATEGORY&userInput=[UI]&aggrLevel=NA&locale=en&matchType=NAME&expand=all&resultCount='
      + this.STATIC_DATA_FETCH_SIZE;
  }

  /**
   * load needed static data
   */
  loadAndSetupStaticData(lock = true) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.loadAndSetupStaticData');
    this.supplierSubscription = this.dataServiceHandler.getSuppliers(TC.Product.TOURS, this.OPERATOR).subscribe(
      data => {
        this.fillUpStaticData(data, this.SUPPLIER_LOAD);

        // set initial selection in refine window
        if (data && data.length > 0 && this.isRefine && this.tourCriteria && this.tourCriteria.supplier) {
          this.selectTourSupplier({code: this.tourCriteria.supplier}, true);
          this.supplierSubscription.unsubscribe();
        }
        if (data && data.length > 0) {
          lock = false;
        }
      },
      error => console.error('Error in fetching Tour Suppliers', error)
    );

    this.dataServiceHandler.getLanguages().subscribe(
      res => {
        if (res) {
          const languages = res.map(lang => ({code: lang.code, value: lang.name}));
          this.guideLanguages = this.addSelectAnyOption(languages, 'Any', this.initialGuideLanguage);
          if (this.isRefine || this.isAmendmentFlow || this.isDpGrab) {
            if (this.tourCriteria && this.tourCriteria.guideLanguage) {
              this.guideLanguages.forEach(lang => {
                if (lang.code === this.tourCriteria.guideLanguage) {
                  lang.selected = true;
                } else {
                  lang.selected = false;
                }
              });
            }
          }
        }
      },
      error => {
        console.log('Error in getting languages');
      });

    this.flexibleOnDates = [{
      code: this.initialFlexibleOnDate, value: 'No', selected: true
    }, {
      code: 1, value: '1 Day', selected: false
    }, {
      code: 3, value: '3 Days', selected: false
    }];
  }

  /**
   * Initial setup the data needed for components
   */
  doInitialSetup() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.doInitialSetup');
    this.loadAndSetupStaticData();
    this.subscription.add(
      this.commonService.getComponentCriteria(TC.Product.TOURS).subscribe(criteria => {
        this.tourCriteria = criteria as TourCriteria;
        if (this.isRefine && this.tourCriteria && this.tourSuppliers && !this.isRefineSupplier &&
          this.tourSuppliers.length > 0 && this.tourCriteria.supplier) {
          this.selectTourSupplier({code: this.tourCriteria.supplier}, true);
        }
      }));

    this.subscription.add(
      this.commonService.getCurrentMsg().subscribe(msg => {
        if (msg == 'triggerReset') {
          this.resetInputs();
        }
      }));

    this.subscription.add(this.commonService.getKeyParamString().subscribe(keyParams => {
      if (keyParams) {
        this.keyParams = this.surfCriteriaUtil.overrideResultCount(keyParams, this.TOU_SEARCH_RESULT_COUNT);
      }
    }));
    if (this.dpTourRefineCriteria) {
      this.tourCriteria = this.dpTourRefineCriteria;
      if ( ( this.isAmendmentFlow || this.isDpGrab ) && this.tourCriteria && this.tourSuppliers && !this.isRefineSupplier &&
        this.tourSuppliers.length > 0 && this.tourCriteria.supplier) {
        this.selectTourSupplier({code: this.tourCriteria.supplier}, true);
      }
    }
    this.setMultiFieldInputProperties();

    this.setInitialRefineValues();
  }

  /**
   * remove item
   */
  removeItem() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.removeItem');
    if (!this.isRefine && !this.isDPSearch) {
      this.commonService.updateComponentCriteria(null, 'TOU');
    }
    this.itemRemoved.emit(this.index);
  }

  /**
   * validate input field for dp flow
   */
  validateInputsForDP() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.validateInputsForDP');
    this.isValid.emit( this.validateInputs() );
  }

  /**
   * set initial values in refine panel here
   */
  setInitialRefineValues() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.setInitialRefineValues');
    if (this.isRefine || this.isAmendmentFlow || this.isDpGrab) {
      if (this.tourCriteria && this.tourCriteria.destinationName) {
        this.selectedDestination.displayText = this.tourCriteria.destinationName +
          (this.tourCriteria.destinationParentCode ? ', ' + this.tourCriteria.destinationParentCode : '');
      }

      if (this.tourCriteria && this.tourCriteria.itineraryName) {
        this.selectedTourName.displayText = this.tourCriteria.itineraryName;
      }

      if (this.tourCriteria && this.tourCriteria.tourDestCities) {
        const tourDestCitySplit = this.tourCriteria.tourDestCities.split(SPLITTER.COMMA_SPLITTER);
        tourDestCitySplit.forEach((city, index) => {
          this.cityPipe.transform(city).subscribe(res => {
            if (res) {
              const nameCodePair = new NameCodePair();
              nameCodePair.code = city;
              nameCodePair.name = res;
              const temp = this.createOntologyData(nameCodePair, index);
              this.stopOntologies.push(temp);
            }
          });
        });
      }

      if (this.tourCriteria && this.tourCriteria.tourCategory) {
        const tourCategorySplit = this.tourCriteria.tourCategory.split(GENERAL_SEPARATORS.FIELD_SEPARATOR);
        tourCategorySplit.forEach((category, index) => {
          this.surfStaticDataService.getTourCategories(category, this.STATIC_DATA_FETCH_SIZE).subscribe(res => {
            if (res && res.data && res.data.length > 0) {
              const nameCodePair = new NameCodePair();
              nameCodePair.code = category;
              nameCodePair.name = res.data[0].name;
              const temp = this.createOntologyData(nameCodePair, index, false);
              this.categoryOntologies.push(temp);
            }
          });
        });
      }
      if (!this.initialDates || this.initialDates?.length === 0 ) {
        this.setRefineDate();
      }

      if (this.tourCriteria && this.tourCriteria.dateOffset) {
        this.selectFlexibleDate({ code: this.tourCriteria.dateOffset }, true);
      }
      if (this.tourCriteria && this.tourCriteria.guideLanguage) {
        this.selectGuideLang({ code: this.tourCriteria.guideLanguage }, true);
      }
    }
  }

  /**
   * set static data
   */
  fillUpStaticData(data, type) {
      TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.fillUpStaticData');
      if (!this.tourCriteria) {
          this.tourCriteria = new TourCriteria();
      }
      if (data && data.length > 0) {
          data.forEach(item => {
            if (type === this.SUPPLIER_LOAD) {
              // find and filter the TOUR_RADAR_SEARCH_AND_BOOK_ENABLED suppliers
              const tourRadarAttr = item?.detail?.attributes?.find(attr => attr.name === 'TOUR_RADAR_SEARCH_AND_BOOK_ENABLED');
              if (tourRadarAttr && tourRadarAttr.value === 'yes') {
                this.tourSuppliers.push({code: item.code, name: item.name, value: item.name, selected: false});
              }
            }
          });
          if (type === this.SUPPLIER_LOAD) {
              this.tourSuppliers.sort((a, b) => {
                  if (a.value < b.value) { return -1; }
                  if (a.value > b.value) { return 1; }
                  return 0;
              });
              this.tourSuppliers = this.addSelectAnyOption(this.tourSuppliers, this.initialCategory);
          }
          if (this.supplierSubscription) {
            this.supplierSubscription.unsubscribe();
          }
      }
  }

  /**
   * set 'select any' option to dropdowns
   */
  addSelectAnyOption(list, defaultValue: string, selectedElementCode = null) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.addSelectAnyOption');
    const surfTextCasePipe = new SurfTextCasePipe(this.configService);
    if (list && list.length > 0) {
      if (!(list[0].code === -1 || list[0].name === defaultValue)) {
        const defaultItem = JSON.parse(JSON.stringify(list[0]));
        defaultItem.value = defaultValue;
        defaultItem.name = defaultValue;
        if (!selectedElementCode) {
          // empty strings should be valid codes
          selectedElementCode = selectedElementCode ?? this.NONE_SELECTED;
          defaultItem.selected = true;
        }
        defaultItem.code = selectedElementCode ?? this.NONE_SELECTED;
        defaultItem.tourDefaultCode = this.NONE_SELECTED;
        list.unshift(defaultItem);
      }
      list.forEach(dropdownItem => {
        if (dropdownItem.value !== defaultValue) {
          dropdownItem.value = surfTextCasePipe.transform(dropdownItem.value, 'title');
          dropdownItem.selected = selectedElementCode === dropdownItem.code;
        }
      });
    }
    return list;
  }

  /**
   *
   * @param $event
   * common passenger selection logic
   */
  getPassengerSelection($event: Array<PaxAllocationItem>) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.getPassengerSelection');
    if ($event != null && this.surfCriteriaUtil.validateChildAges($event) && this.surfCriteriaUtil.validateTeenAges($event)) {
      this.tourCriteria.adult = this.surfCriteriaUtil.processAdultPaxAllocation($event, this.DEFAULT_ADULT_AGE);

      const children = this.processChildAllocation($event);
      const teens = this.processTeenAllocation($event);
      const infant = this.processInfantAllocation($event);
      if (children.CHD && children.CHD.length > 0) {
        this.tourCriteria.child = children.CHD;
      } else {
        this.tourCriteria.child = null;
      }
      if (teens && teens.length > 0) {
        this.tourCriteria.teen = teens;
      } else {
        this.tourCriteria.teen = null;
      }
      this.tourCriteria.infant = infant && infant.length > 0 ? infant : null;

      this.commonService.updateComponentCriteria(this.tourCriteria, TC.Product.TOURS);
    } else {
      this.tourCriteria.adult = null;
      this.tourCriteria.child = null;
      this.tourCriteria.teen = null;
      this.tourCriteria.infant = null;
      this.commonService.updateComponentCriteria(this.tourCriteria, TC.Product.TOURS);
    }

  }

  /**
   * process child allocation
   * @param paxArray
   */
  processChildAllocation(paxArray: Array<PaxAllocationItem>) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.processChildAllocation');
    const children = {
      INF: '',
      CHD: '',
    };

    let roomNo = 1;
    paxArray.forEach(paxRoom => {
      if (paxRoom.child.length > 0) {
        // Initialize an array to store the generated strings
        const result: string[] = paxRoom.child.map(age => {
          // Construct the string for each age
          let str = `1${this.FIELD_SEPERATOR}${age}${this.FIELD_SEPERATOR}DOB${this.FIELD_SEPERATOR}${roomNo}${this.AGE_SEPERATOR}`;
          return str;
        });
        children.CHD += result.join('');
      }
      roomNo++;
    });

    if (children.CHD.length > 2) {
      children.CHD = children.CHD.slice(0, children.CHD.length - 2);
    }

    return children;
  }

  /**
   * process infant allocation
   * @param paxArray
   */
  processInfantAllocation(paxArray: Array<PaxAllocationItem>) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.processInfantAllocation');
    let roomNo = 1;
    let inf = '';
    paxArray.forEach(paxRoom => {
      // Initialize an array to store the generated strings
      const result: string[] = paxRoom.infant.map(age => {
        // Construct the string for each age
        return `1${this.FIELD_SEPERATOR}${age}${this.FIELD_SEPERATOR}DOB${this.FIELD_SEPERATOR}${roomNo}${this.AGE_SEPERATOR}`;
      });
      inf += result.join('');
      roomNo++;
    });
    return inf;
  }

  /**
   * process teen allocation
   * @param paxArray
   */
  processTeenAllocation(paxArray: Array<PaxAllocationItem>) {

    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.processTeenAllocation');

    let teens = '';
    // teens
    let roomNo = 1;
    paxArray.forEach(paxRoom => {
      if (paxRoom.teen.length > 0) {
        let teenAgeMap = {};
        const teenOrder = [];
        paxRoom.teen.forEach(teenAge => {
          if (teenOrder.findIndex(age => age === teenAge) < 0) {
            teenOrder.push(teenAge);
          }
        });
        paxRoom.teen.forEach(teenAge => {
          teenAgeMap[teenAge] ? teenAgeMap[teenAge]++ : teenAgeMap[teenAge] = 1;
        });
        for (let age of teenOrder) {
          const key = age + '';
          let count = teenAgeMap[key] + '';
          /* TODO update this logic based on guest age setup */
          /*teens*/
          teens += count + this.FIELD_SEPERATOR + key + this.FIELD_SEPERATOR + 'DOB';
          teens += this.AGE_SEPERATOR;

        }
      }
      roomNo++;
    });

    if (teens.length > 2) {
      teens = teens.slice(0, teens.length - 2);
    }
    return teens;
  }

  onKeyDown($event, component) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.onKeyDown');
    if ($event.keyCode === KeyCodes.ENTER) {
      if (component === 0) {
        setTimeout(() => {
          this.guestComponentFocus = false;
        }, 200);
      } else if (component === 1) {
        if (this.currentPaxOption === 3) {
          if (this.enterPressed && this.tourCriteria &&
            (this.tourCriteria.nights === undefined || this.tourCriteria.nights === 0)) {
            setTimeout(() => {
              this.guestComponentFocus = false;
            }, 200);
          }
          this.enterPressed = true;
        }
        if (this.currentPaxOption !== 3 && this.tourCriteria &&
          (this.tourCriteria.nights === undefined || this.tourCriteria.nights === 0)) {
          setTimeout(() => {
            this.guestComponentFocus = false;
          }, 200);
          this.enterPressed = false;
        }
      }
    }

    if ($event.keyCode === KeyCodes.UPARROW || $event.keyCode === KeyCodes.DOWNARROW) {
      if (component === 1 && this.currentPaxOption === 3) {
        this.enterPressed = false;
      }
    }

    if ($event.keyCode === KeyCodes.RIGHTARROW) {
      if (component === 1 && this.currentPaxOption === 3) {
        this.enterPressed = true;
      }
    }
  }

  /**
   * scroll to logic
   */
  scrollTo(selector) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.scrollTo');
    if (!this.isDPSearch) {
      if (this.windowScrollEnable) {
        SurfScrollDirective.scrollTo(selector, null, false, false, 0, 60);
      }
    }
  }

  getCurrentOption($event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.getCurrentOption');
    this.currentPaxOption = $event;
  }

  closeCriteriaBox() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.closeCriteriaBox');
    if (!this.isRefine && !this.isDPSearch) {
      this.commonService.changeMessage('TOU_close');
      this.commonService.updateComponentCriteria(null, TC.Product.TOURS);
    }
    if (this.isRefine) {
      this.cancelRefineSearch();
    }
  }

  cancelRefineSearch() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.cancelRefineSearch');
    this.cancelRefine.emit(this.isRefine);
  }

  /**
   * move to dp flow when add another item from the component flow.
   */
  moveToDP(position: string) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.moveToDP');
    if (!this.isDPSearch) {
      this.msg = 'DP_Switch~TOU~' + position;
    }
  }

  // todo when DP flow, update criteria using these methods
  /**
   * error validation with typeahead results
   */
  returnedSearchQueryForStops(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.returnedSearchQueryForStops');
    this.stopSearchInitialized = event && event.length >= 3;
    this.depPortPartiallyTyped = !!event;
  }

  /**
   * error validation with typeahead results
   */
  returnedSearchQueryForDepartureCity(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.returnedSearchQueryForDepartureCity');
    this.destSearchInitiated = event && event.length >= 3;
    this.depPortPartiallyTyped = !!event;
  }

  /**
   * onClickInsideDestTypeAhead selectedDestination
   * @param event
   */
  onClickInsideDestTypeAheadDepartureCity(event) {

    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.onClickInsideDestTypeAheadDepartureCity');

    const tourCri = this.tourCriteria;
    if (tourCri) {
      if (tourCri.destinationType === DestinationType.CITY) {
        this.selectedDestination.displayText = tourCri.destinationName.trim();
      }
    }
  }

  /**
   * onClickInsideDestTypeAhead TourName
   * @param event
   */
  onClickInsideDestTypeAheadTourName(event) {

    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.onClickInsideDestTypeAheadTourName');

    const tourCri = this.tourCriteria;
    if (tourCri) {
      if ( this.tourCriteria.itineraryName ) {
        this.selectedTourName.displayText = this.tourCriteria.itineraryName.split(' ')[0].trim();
      }
    }
  }

  /**
   * onClickOutsideDestTypeAhead TourName
   * @param event
   */
  onClickOutsideDestTypeAheadTourName(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.onClickOutsideDestTypeAheadTourName');
    this.selectedTourName.displayText = this.tourCriteria?.itineraryName?.trim();
  }


  /**
   * onClickOutsideDestTypeAhead selectedDestination
   * @param event
   */
  onClickOutsideDestTypeAheadDepartureCity(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.onClickOutsideDestTypeAheadDepartureCity');
    const surfTextCasePipe = new SurfTextCasePipe(this.configService);

    const tourCri = this.tourCriteria;

    if (tourCri) {
      if (tourCri.destinationType === DestinationType.CITY && tourCri.destinationName && tourCri.destinationName !== 'undefined') {
        this.selectedDestination.displayText = tourCri.destinationName.trim() + ((tourCri.destinationParentCode &&
          !tourCri.destinationParentCode.includes('undefined')) ? ', ' + tourCri.destinationParentCode : '');
      }
      if (this.isRefine && tourCri.destinationType === DestinationType.COUNTRY && tourCri.destinationName
        && tourCri.destinationName !== 'undefined') {
        this.selectedDestination.displayText = surfTextCasePipe.transform(tourCri.destinationName, 'title').trim();
      }
    }
    if (this.isDPSearch || this.isAmendmentFlow) {
      this.validateInputsForDP();
    }
  }


  /**
   * error validation with typeahead results
   */
  returnedSearchQueryForTourName(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.returnedSearchQueryForTourName');
    this.nameSearchInitialized = event && event.length >= 3;
    this.depPortPartiallyTyped = !!event;
  }

  /**
   * error validation with typeahead results
   */
  returnedSearchQueryForCategory(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.returnedSearchQueryForCategory');
    this.categorySearchInitialized = event && event.length >= 3;
    this.depPortPartiallyTyped = !!event;
  }

  // ----------------------------------------------- typeahead data set to display list----------------------

  /**
   * criteria set to empty when no result, display hide
   */
  returnedStop(data) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.returnedStop');
    if (data && data.length > 0) {
      this.filteredTourStop = data;
    } else {
      this.filteredTourStop = [];
      if (this.tourCriteria && this.stopOntologies && this.stopOntologies.length === 0) {
        this.tourCriteria.tourDestCities = null;
      }
    }
  }

  /**
   * criteria set to empty when no result, display hide
   */
  returnedDepartureCity(data) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.returnedDepartureCity');
    if (data && data.length > 0) {
      this.filteredDestinationCity = data;
    } else {
      this.filteredDestinationCity = [];
      if (this.tourCriteria) {
        this.tourCriteria.destinationName = null;
        this.tourCriteria.destinationCode = null;
        this.tourCriteria.city = null;
        this.tourCriteria.country = null;
      }
    }
  }

  /**
   * criteria set to empty when no result, display hide
   */
  returnedTourName(data) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.returnedTourName');
    if (data && data.length > 0) {
      const userEnteredQuery = {
        code: this.selectedTourName?.displayText,
        name: this.selectedTourName?.displayText,
        type: 220,
        parent: [],
        attributes: []
      };
      data.unshift(userEnteredQuery);
      this.filteredTourName = data;
      // this.filteredTourName = this.tourCriteria.supplier ? data : data.filter(item => {
      //   const tourRadarAttr = item.attributes.find(attr => attr.name === 'TOUR_RADAR_SEARCH_AND_BOOK_ENABLED');
      //   return tourRadarAttr && (tourRadarAttr.value === 'yes');
      // });
    } else {
      this.filteredTourName = [];
      if (this.tourCriteria) {
        this.tourCriteria.itineraryName = null;
      }
    }
  }

  /**
   * criteria set to empty when no result, display hide
   */
  returnedTourCategory(data) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.returnedTourCategory');
    if (data && data.length > 0) {
      this.filteredTourCategory = data;
    } else {
      this.filteredTourCategory = [];
      if (this.tourCriteria && this.categoryOntologies && this.categoryOntologies.length === 0) {
        this.tourCriteria.tourCategory = null;
      }
    }
  }

  /**
   * add parent location details to child location object.
   */
  addParentToLocationGroup(locationGroup, city) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.addParentToLocationGroup');
    const parent = [];
    if (city) {
      parent.push({code: city.code, name: city.name, type: city.type});  /*add city*/
    }
    if (city.parent && city.parent[0]) {
      parent.push({code: city.parent[0].code, name: city.parent[0].name, type: city.parent[0].type});  /*add country*/
    }
    locationGroup.parent = parent;
    return locationGroup;
  }

  /**
   * set tour suppliers
   */
  selectTourSupplier(event, isForced = false) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.selectTourSupplier');
    if (event && event.code) {
      // update tourNameURL when supplier changes
      if (event.code === '-1') {
        this.tourNameURL = `${this.STATIC_DATA_URL_BASE}?dataTypes=TOUR_NAME&userInput=[UI]&aggrLevel=NA&locale=en&matchType=NAME&expand=all&resultCount=${this.STATIC_DATA_FETCH_SIZE}`;
      } else {
        // reset tour name if supplier changes
        if (event.code !== this.tourCriteria.supplier) {
          this.resetTourName();
        }
        this.tourNameURL = `${this.STATIC_DATA_URL_BASE}?dataTypes=TOUR_NAME&userInput=[UI]&aggrLevel=NA&locale=en&matchType=NAME&expand=all&resultCount=${this.STATIC_DATA_FETCH_SIZE}&parentType=${this.OPERATOR}&parentCode=${event.code}`;
      }

      this.tourSuppliers.forEach(line => {
        if (event.code !== this.NONE_SELECTED) {
          if (event.code === line.code) {
            line.selected = true;
            if (this.tourCriteria) {
              this.tourCriteria.supplier = event.code;
            }
          } else {
            line.selected = false;
          }
        } else {
          line.selected = false;
          if (this.tourCriteria) {
            this.tourCriteria.supplier = null;
          }
        }
      });
      if (isForced && this.tourSuppliers && this.tourSuppliers.length > 0) {
        this.tourSuppliers = JSON.parse(JSON.stringify(this.tourSuppliers));
        this.isRefineSupplier = true;
      }
      if (!this.isRefine && !this.isDPSearch) {
        this.commonService.updateComponentCriteria(this.tourCriteria, TC.Product.TOURS);
      }
    }
  }

  // -------------------------Date Picker logics ------------------------------------
  /**
   * get selected months from calendar month
   */
  getMonthSelection($event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.getMonthSelection');
    if ($event !== null && $event[0] !== '') {
      this.isDateNotSelected = false;
      this.defaultActiveCalendar = CALENDAR_VIEW.SINGLE_MONTH_VIEW;
      if (this.tourCriteria) {
        this.tourCriteria.startDate = null;
        this.tourCriteria.startMonth = this.surfCriteriaUtil.getMonthStr($event[0]);
        this.tourCriteria.startYear = this.surfCriteriaUtil.getYearStr($event[0]);
      }
      if (!this.isDPSearch ) {
        this.commonService.updateBaseCriteria(this.tourCriteria);
      }
      if ( this.isDPSearch ) {
        this.validateInputsForDP();
      }
    }
  }

  /**
   * get selected dates from calendar
   */
  getDateSelection($event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.getDateSelection');
    if ($event) {
      this.isDateNotSelected = false;
      this.defaultActiveCalendar = CALENDAR_VIEW.SINGLE_DATE_VIEW;
      if (this.tourCriteria) {
        this.tourCriteria.startDate = this.surfCriteriaUtil.convertDateObjToStr($event[0]);
        this.travellerEarliestDepartureDateService
          .setEarliestDepartureDateFromComponentCriteriaForNewlyAddedItem(this.tourCriteria.startDate);
        this.tourCriteria.startMonth = null;
        this.tourCriteria.startYear = null;
      }
      if ( this.isDPSearch ) {
        this.validateInputsForDP();
      }
      if (!this.isDPSearch ) {
        this.commonService.updateBaseCriteria(this.tourCriteria);
      }
    } else {
      this.isDateNotSelected = true;
      if ( this.isDPSearch ) {
        this.validateInputsForDP();
      }
    }
  }

  /**
   * set multi field details
   */
  createMultiSelectCriteriaString(ontologies, isCommaSeparated = true) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.createMultiSelectCriteriaString');
    let separator = SPLITTER.COMMA_SPLITTER;
    if (!isCommaSeparated) {
      separator = GENERAL_SEPARATORS.FIELD_SEPARATOR;
    }
    if (ontologies.length > 0) {
      let returningText = '';
      this.destNames = '';
      ontologies.forEach(ontology => {
        if (returningText.length > 0) {
          returningText += separator;
          this.destNames += separator;
        }
        if (ontology && ontology.query) {
          returningText += ontology.query;
          this.destNames += ontology.displayText;
        } else {
          console.error('Error in setting data codes');
        }
      });
      return returningText;
    }
    return null;
  }

  // ------------------------------destination typeahhead --------------------------------
  /**
   * select data logic for stops
   */
  selectStops(data) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.selectStops');
    if (this.stopOntologies && this.stopOntologies.filter(ontology =>
      ontology.displayText === this.getOntologyDisplayText(data)).length === 0) {
      this.stopOntologies.push(this.createOntologyData(data, this.stopOntologies.length));
      this.setCalendarMinDate(data);
      this.surfCalendarStartDateService.updateMinDate(this.calendarMinDate, TC.Product.TOURS);
    }
    if ((data.type === 'CITY' || data.type === 40) && this.tourCriteria && this.stopOntologies && this.stopOntologies.length > 0) {
      this.tourCriteria.tourDestCities = this.createMultiSelectCriteriaString(this.stopOntologies);
    }
    this.selectedStop.displayText = null;
    this.filteredTourStop = [];

    this.stopSearchInitialized = false;
    if (!this.isRefine && !this.isDPSearch && !this.isAmendmentFlow) {
      this.commonService.updateComponentCriteria(this.tourCriteria, TC.Product.TOURS);
    }
    if ( this.isDPSearch ) {
      this.validateInputsForDP();
    }
  }

  /**
   * select data logic for stops
   */
  removeSelectedStop(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.removeSelectedStop');
    this.stopOntologies = this.stopOntologies.filter(ontology => ontology.displayText !== event.value);
    if (this.tourCriteria && this.stopOntologies) {
      this.tourCriteria.tourDestCities = this.createMultiSelectCriteriaString(this.stopOntologies);
    }
    if ( this.isDPSearch ) {
      this.validateInputsForDP();
    }
  }

  /**
   * select data logic for stops
   */
  selectDestination(data) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.selectDestination');
    this.filteredDestinationCity = [];
    this.setCalendarMinDate(data);
    this.surfCalendarStartDateService.updateMinDate(this.calendarMinDate, TC.Product.TOURS);
    if (data.type === 'CITY' || data.type === 40) {
      this.selectedDestination.displayText = data.name +
        (this.surfCriteriaUtil.getCountry(data) ? ', ' + this.surfCriteriaUtil.getCountry(data) : '');
      if (this.tourCriteria) {
        this.tourCriteria.destinationType = DestinationType.CITY;
        this.tourCriteria.destinationParentCode = this.surfCriteriaUtil.getCountry(data);
        this.tourCriteria.city = data.code;
        this.tourCriteria.country = this.surfCriteriaUtil.getCountryCode(data);
      }
    } else {
      this.selectedDestination.displayText = data.name;
      if (this.tourCriteria) {
        this.tourCriteria.destinationType = DestinationType.COUNTRY;
        this.tourCriteria.country = data.code;
      }
    }
    this.selectedDestination.displayText = this.selectedDestination.displayText.trim();
    this.destSearchInitiated = false;
    if (this.tourCriteria) {
      this.tourCriteria.destinationCode = data.code;
      this.tourCriteria.destinationName = data.name;
    }

    if (!this.isRefine && !this.isDPSearch && !this.isAmendmentFlow) {
      this.commonService.updateComponentCriteria(this.tourCriteria, TC.Product.TOURS);
    }
  }

  /**
   * select data logic for stops
   */
  selectTourName(data) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.selectTourName');
    this.filteredTourName = [];
    this.setCalendarMinDate(data);
    this.surfCalendarStartDateService.updateMinDate(this.calendarMinDate, TC.Product.TOURS);
    if (data.type === 210 || data.type === 220) {
      this.selectedTourName.displayText = data.name;
      if (this.tourCriteria) {
        this.tourCriteria.itineraryName = data.name;
      }
    }
    this.selectedTourName.displayText = this.selectedTourName.displayText.trim();
    this.nameSearchInitialized = false;

    if (!this.isRefine && !this.isDPSearch && !this.isAmendmentFlow) {
      this.commonService.updateComponentCriteria(this.tourCriteria, TC.Product.TOURS);
    }
  }

  /**
   * select data logic for tour category
   */
  selectTourCategory(data) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.selectTourCategory');
    this.filteredTourCategory = [];
    if (this.categoryOntologies && this.categoryOntologies.filter(ontology =>
      ontology.displayText === this.getOntologyDisplayText(data, false)).length === 0) {
      this.categoryOntologies.push(this.createOntologyData(data, this.categoryOntologies.length, false));
      this.setCalendarMinDate(data);
      this.surfCalendarStartDateService.updateMinDate(this.calendarMinDate, TC.Product.TOURS);
    }
    if ((data.type === 230 || data.type === 240) && this.tourCriteria && this.categoryOntologies && this.categoryOntologies.length > 0) {
      this.tourCriteria.tourCategory = this.createMultiSelectCriteriaString(this.categoryOntologies, false);
    }
    this.selectedTourCategory.displayText = null;
    this.categorySearchInitialized = false;
    if (!this.isRefine && !this.isDPSearch && !this.isAmendmentFlow) {
      this.commonService.updateComponentCriteria(this.tourCriteria, TC.Product.TOURS);
    }
  }

  /**
   * remove category chip
   */
  removeSelectedTourCategory(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.removeSelectedTourCategory');
    this.categoryOntologies = this.categoryOntologies.filter(ontology => ontology.displayText !== event.value);
    if (this.tourCriteria && this.categoryOntologies) {
      this.tourCriteria.tourCategory = this.createMultiSelectCriteriaString(this.categoryOntologies, false);
    }
  }

  /**
   * set calendar details
   *
   */
  setCalendarMinDate(data) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.setCalendarMinDate');
    const currentTime = data.attributes.filter(attribute => attribute.name === 'current_time');
    if (currentTime.length > 0 && this.calendarMinDate > this.surfCriteriaUtil.getDateFromString(currentTime[0])) {
      this.calendarMinDate = new Date(currentTime[0].value);
    }
  }

  // --------------------------------------------------------------
  /**
   * Creating ontology data
   *
   */
  createOntologyData(data: any, index: number, isWithCode = false): OntologyResponse {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.createOntologyData');
    const res = new OntologyResponse();
    if (data) {
      res.displayText = this.getOntologyDisplayText(data, isWithCode);
      res.query = data.code;
      res.index = index;
    }
    return res;
  }

  /**
   *  chip display
   */
  getOntologyDisplayText(data, isWithCode = false) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.getOntologyDisplayText');
    return (isWithCode) ? data.name + ' (' + data.code + ')' : data.name;
  }

  /**
   * input validation based on UI visibility
   * @return boolean true if a error doesn't exist
   */
  validateInputIfVisible(): boolean {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.validateInputIfVisible');
    let hasError = false;

    if (!(this.visibilityConfig['tour.search_tour_criteria.guide_language'] && this.tourCriteria.guideLanguage)) {
      hasError = true;
    }
    if (!(this.visibilityConfig['tour.search_tour_criteria.flexible_on_dates'] && this.tourCriteria.dateOffset)) {
      hasError = true;
    }

    return !hasError;
  }

  /**
   * validate all component inputs
   */
  validateInputs() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.validateInputs');
    const isLastMinuteBookingValidationPass = this.surfCalendarStartDateService.lastMinuteBookingErrorSet.size <= 0;
    let isAllInputsPresent = false;
    if ((this.tourCriteria && this.tourCriteria.adult && !this.isDateNotSelected &&
      (this.tourCriteria.startDate || this.tourCriteria.startMonth && this.tourCriteria.startYear) &&
      this.tourCriteria.city) || this.isGrabbed && this.validateInputIfVisible()) {
      isAllInputsPresent = true;
    }
    if ((this.tourCriteria && this.isDPSearch && !this.isDateNotSelected &&
      (this.tourCriteria.startDate || this.tourCriteria.startMonth && this.tourCriteria.startYear) &&
      this.tourCriteria.city)) {
      isAllInputsPresent = true;
    }
    if (this.isGrabbed && this.displayingGrabbedTourDetailList && this.displayingGrabbedTourDetailList &&
      this.displayingGrabbedTourDetailList.filter(displayData => displayData.isBlockedResult && displayData.isOpenToShow).length > 0) {
      isAllInputsPresent = false;
    } else if (this.isGrabbed && this.displayingGrabbedTourDetailList && this.displayingGrabbedTourDetailList &&
      this.displayingGrabbedTourDetailList.filter(displayData => displayData.isBlockedResult && displayData.isOpenToShow).length === 0) {
      isAllInputsPresent = true;
    } else if ( this.isDpGrab && !this.grabBlockDetails?.code) {
      isAllInputsPresent = true;
    }
    if (this.isAmendmentFlow) {
      return isLastMinuteBookingValidationPass && isAllInputsPresent;
    } else {
      return isAllInputsPresent;
    }
  }

  /**
   * validate duration input value
   * @duration
   */
  validateDuration(duration: string) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.validateDuration');
    if (duration !== null) {
      const value = duration.toString().replace(/[^0-9]*/g, '');
      if (value === duration) {
        if (parseInt(duration, 10) > 0) {
          return true;
        }
      }
      return false;
    }
    return false;
  }

  // ---------------------------- Reset values -------------------------------------
  /**
   * Upon clicking the reset/cancel button, all the input fields and corresponding
   * values in the criteria object will be reset
   */
  resetInputs(isRefine?: boolean) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.resetInputs');
    if (!isRefine) {
      this.isGrabbed = false;
      this.resetDisplayItems();
      this.setMultiFieldInputProperties();
    } else {
      this.cancelRefineSearch();
    }
    if (this.isServiceAddComponent) {
      this.cancelRefine.emit(true);
    }
  }

  resetDestination() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.resetDestination');
    this.cleanOntology(this.selectedDestination);
    if (this.tourCriteria) {
      this.tourCriteria.destinationName = '';
      this.tourCriteria.destinationCode = null;
      this.tourCriteria.city = null;
      this.tourCriteria.country = null;
    }
  }

  resetTourName() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.resetTourName');
    this.cleanOntology(this.selectedTourName);
    if (this.tourCriteria) {
      this.tourCriteria.itineraryName = null;
    }
  }

  resetStops() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.resetStops');
    this.cleanOntology(this.selectedStop);
    this.stopOntologies = [];
    if (this.tourCriteria) {
      this.tourCriteria.tourDestCities = null;
    }
  }

  resetDate() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.resetDate');
    this.resetCalendar = true;   // todo: try this without timeout using this.resetCalendar = !this.resetCalendar
    setTimeout(() => {
      this.resetCalendar = false;
    }, 0);
    if (this.tourCriteria) {
      this.tourCriteria.startDate = null;
      this.tourCriteria.startMonth = null;
      this.tourCriteria.startYear = null;
    }
    this.initialDates = [];
  }

  resetCategory() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.resetCategory');
    this.cleanOntology(this.selectedTourCategory);
    this.categoryOntologies = [];
    if (this.tourCriteria) {
      this.tourCriteria.tourCategory = null;
    }
  }

  resetTourSupplier() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.resetTourSupplier');
    this.tourSuppliers.forEach(ele => {
      ele.selected = ele.code === this.NONE_SELECTED;
    });
    this.tourSuppliers = JSON.parse(JSON.stringify(this.tourSuppliers));
    if (this.tourCriteria) {
      this.tourCriteria.supplier = null;
    }
  }

  resetDuration() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.resetDuration');
    if (this.tourCriteria) {
      this.tourCriteria.durationRange = null;
    }
  }

  resetGuideLanguage() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.resetGuideLanguage');
    this.guideLanguages.forEach(ele => {
      ele.selected = ele.code === this.initialGuideLanguage;
    });
    this.guideLanguages = JSON.parse(JSON.stringify(this.guideLanguages));
    if (this.tourCriteria) {
      this.tourCriteria.guideLanguage = this.initialGuideLanguage;
    }
  }

  resetFlexOnDate() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.resetFlexOnDate');
    this.flexibleOnDates.forEach(ele => {
      ele.selected = ele.code === this.initialFlexibleOnDate;
    });
    this.flexibleOnDates = JSON.parse(JSON.stringify(this.flexibleOnDates));
    if (this.tourCriteria) {
      this.tourCriteria.dateOffset = this.initialFlexibleOnDate;
    }
  }

  resetAdvancedSearch() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.resetAdvancedSearch');
    this.tourCriteria.privateTour = null;
    this.tourCriteria.promotionCode = null;
    this.tourCriteria.resort = null;
  }

  resetDisplayItems() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.resetDisplayItems');
    this.grabbedTourId = '';
    this.defaultPaxSet = [];
    this.stopSearchInitialized = false;
    this.destSearchInitiated = false;
    this.nameSearchInitialized = false;
    this.categorySearchInitialized = false;
    this.resetDate();
    this.resetDuration();
    this.resetDestination();
    this.resetStops();
    this.resetCategory();
    this.resetTourSupplier();
    this.resetTourName();
    this.resetAdvancedSearch();
  }

  cleanOntology(ontology: OntologyResponse) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.cleanOntology');
    ontology.displayText = '';
    ontology.index = 0;
    ontology.query = '';
  }

  // ---------------------------------------------------------------------
  /**
   * set properties for duration selection multi-field-input
   */
  setMultiFieldInputProperties() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.setMultiFieldInputProperties');
    this.durationProperty = [];
    this.durationValues = [];

    if (this.visibilityConfig['tour.search_tour_criteria.editable_duration']) {
      this.durationProperty.push(MultiFieldInputPropertyFactory.getInputProperties(
        true, 'Any', false, true, 'number', '', 'durationValue', ''));

      this.durationProperty.push(MultiFieldInputPropertyFactory.getDropdownProperties(
        false,
        '',
        false,
        false,
        'button',
        'durationType'
      ));
    } else {
      this.durationProperty.push(MultiFieldInputPropertyFactory.getInputProperties(
        true, 'Any', false, false, 'number', '', 'durationValue', ''));

      this.durationProperty.push(MultiFieldInputPropertyFactory.getInputProperties(
        true,
        '',
        false,
        true,
        'text',
        '',
        'durationType',
        ''
      ));
    }

    if (
      this.isRefine ||
      this.isGrabbed ||
      ((this.isAmendmentFlow || this.isDpGrab) &&
        this.tourCriteria &&
        this.tourCriteria.durationRange)
    ) {
      let currentDurationArr;
      if (this.tourCriteria && this.tourCriteria.durationRange) {
        currentDurationArr = this.tourCriteria.durationRange.split(
          GENERAL_SEPARATORS.FIELD_SEPARATOR
        );
      }

      this.durationValues.push(
        new MultiFieldInputData(
          '',
          currentDurationArr && currentDurationArr[1]
            ? currentDurationArr[1]
            : ''
        )
      );
    } else {
      this.durationValues.push(new MultiFieldInputData('', ''));
    }

    if (this.visibilityConfig['tour.search_tour_criteria.editable_duration']) {
      if (!this.isRefine) {
        this.durationValues.push([
          new MultiFieldInputData('ANY', 'Any', true),
          new MultiFieldInputData('D', 'Days'),
          new MultiFieldInputData('H', 'Hours'),
          new MultiFieldInputData('N', 'Nights'),
          new MultiFieldInputData('M', 'Minutes'),
          new MultiFieldInputData('O', 'Days / Nights'),
        ]);
      } else {
        this.durationValues.push([
          new MultiFieldInputData('ANY', 'Any', this.tourCriteria.durationType === null || this.tourCriteria.durationType === ''
          || this.tourCriteria.durationType === 'ANY'),
          new MultiFieldInputData('D', 'Days', this.tourCriteria.durationType === 'D'),
          new MultiFieldInputData('H', 'Hours', this.tourCriteria.durationType === 'H'),
          new MultiFieldInputData('N', 'Nights', this.tourCriteria.durationType === 'N'),
          new MultiFieldInputData('M', 'Minutes', this.tourCriteria.durationType === 'M'),
          new MultiFieldInputData('O', 'Days / Nights', this.tourCriteria.durationType === 'O'),
        ]);
      }
    } else {
      this.durationValues.push(new MultiFieldInputData(this.DURATION_CATEGORIES.code, this.DURATION_CATEGORIES.value));
    }
  }

  getNewDurationValue(data) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.getNewDurationValue');
    const durationValues = [];
    durationValues.push(new MultiFieldInputData('', data ? data : ''));
    durationValues.push(new MultiFieldInputData(this.DURATION_CATEGORIES.code, this.DURATION_CATEGORIES.value));
    return durationValues;
  }

  /**
   *  set duration using disabled duration input
   */
  setDuration(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.setDuration');
    if (event && event[0] && event[0].value && this.tourCriteria) {
      this.tourCriteria.durationRange = event[0].value + GENERAL_SEPARATORS.FIELD_SEPARATOR + event[0].value;
      this.durationError = !this.validateDuration(event[0].value);
    } else {
      if (this.tourCriteria) {
        this.tourCriteria.durationRange = null;
      }
    }
  }

  /**
   * set duration using enabled duration input
   */
  setDurationForAdvancedSearch(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.setDurationForAdvancedSearch');
    if (event[1]) {
      const element = event[1];

      this.durationProperty[0].disabled = true;

      this.tourCriteria.durationType = element.code;

      if (element.code === null) {
        this.durationProperty[0].disabled = true;
        this.durationValues[0] = new MultiFieldInputData('', '');
        this.tourCriteria.durationRange = null;
      } else {
        this.durationProperty[0].disabled = false;
      }
    }

    if (event[0]) {
      const element = event[0];

      this.tourCriteria.durationRange =
      event[1].code !== null
          ? element + GENERAL_SEPARATORS.FIELD_SEPARATOR + element
          : '';
      this.durationError = !this.validateDuration(
        element
      );
    }
  }

  /**
   * Construct the tour search URL and redirect to the results page
   */
  searchTour(isExternal?) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.searchTour');
    const basePath = '/';
    if (this.isServiceAddComponent && this.tourCriteria) {
      const criteriaUrl = basePath + 'b2b-tours/?' + this.keyParams + this.getTourSearchUrlParams();
      this.getUrlCriteria.emit({url: criteriaUrl, isExternal});
    } else {
      if (this.tourCriteria) {
        window.location.href = basePath + 'b2b-tours/?' + this.keyParams + this.getTourSearchUrlParams();
      }
    }
  }

  /**
   * create URL parameters
   */
  getTourSearchUrlParams() {
      TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.getTourSearchUrlParams');
      if (this.tourCriteria.adult) {
          this.tourCriteria.adult = this.tourCriteria.adult.replace(/DOB/g, ''); // removing DOB from adult
      }
      // get child guest related params
      let childParams = '';
      if (this.tourCriteria.teen && this.tourCriteria.teen.length > 0) {
          this.tourCriteria.teen = this.tourCriteria.teen.replace(/DOB/g, ''); // removing DOB from child
          childParams = '&child=' + this.tourCriteria.teen;
      }
      if (this.tourCriteria.child && this.tourCriteria.child.length > 0) {
          if (childParams.toString().includes('&child')) {
              this.tourCriteria.child = this.tourCriteria.child.replace(/DOB/g, ''); // removing DOB from child
              childParams = childParams + this.AGE_SEPERATOR + this.tourCriteria.child;
          } else {
              this.tourCriteria.child = this.tourCriteria.child.replace(/DOB/g, ''); // removing DOB from child
              childParams = '&child=' + this.tourCriteria.child;
          }
      }
      if (this.tourCriteria.infant && this.tourCriteria.infant.length > 0) {
          childParams += '&infant=' + this.tourCriteria.infant;

      }
      const loginUserToday = new Date();
      if (this.isGrabbed) {
          loginUserToday.setDate(loginUserToday.getDate() + 7);
      }
      let returningQueryString = new StringConcatenationClass()
          .appendString('&adult=' + this.tourCriteria.adult + childParams, !!(this.tourCriteria.adult + childParams))
          .appendString('&tourDestCities=' + this.tourCriteria.tourDestCities, !!this.tourCriteria.tourDestCities)
          .appendString('&city=' + this.tourCriteria.city, !!this.tourCriteria.city)
          .appendString('&startDate=' + this.tourCriteria.startDate, !!this.tourCriteria.startDate
              && !this.tourCriteria.startMonth && !this.isGrabbed)
          .appendString('&startDate=' + this.surfUtilService.getDateString(loginUserToday), this.isGrabbed)
          .appendString('&durationType=' + 'D', !this.ENABLED_EXTENDED_TOUR_SEARCH_CRITERIA)
          .appendString('&durationType=' + 'ANY', this.ENABLED_EXTENDED_TOUR_SEARCH_CRITERIA &&
            !this.visibilityConfig['tour.search_tour_criteria.editable_duration'])
          .appendString('&startMonth=' + this.tourCriteria.startMonth, !!this.tourCriteria.startMonth)
          .appendString('&startYear=' + this.tourCriteria.startYear, !!this.tourCriteria.startYear)
          .appendString('&bookingDate=' + this.tourCriteria.bookingDate, !!this.tourCriteria.bookingDate)
          .appendString('&durationRange=' + this.tourCriteria.durationRange, !!this.tourCriteria.durationRange)
          .appendString('&supplier=' + this.tourCriteria.supplier, !!this.tourCriteria.supplier)
          .appendString('&privateTour=' + this.tourCriteria.privateTour, !!this.tourCriteria.privateTour)
          .appendString('&sourceInfo=' + this.tourCriteria.sourceInfo, !!this.tourCriteria.sourceInfo)
          .appendString('&sources=' + this.tourCriteria.sources, !!this.tourCriteria.sources && this.isGrabbed)
          .appendString(
              '&itineraryName=' + this.surfUtilService.encodeSpecialCharacters(this.tourCriteria.itineraryName, '&'),
              !!this.tourCriteria.itineraryName
          )
          .appendString('&destNames=' + this.destNames, !!this.destNames)
          .appendString('&destinationName=' + this.tourCriteria.destinationName, !!this.tourCriteria.destinationName)
          .appendString('&destinationParentCode=' + this.tourCriteria.destinationParentCode, !!this.tourCriteria.destinationParentCode)
          .appendString('&tourCategory=' + this.tourCriteria.tourCategory, !!this.tourCriteria.tourCategory)
          // advanced search
          .appendString(`&durationType=${this.tourCriteria.durationType || 'ANY'}`,
            this.visibilityConfig['tour.search_tour_criteria.editable_duration'])
          .appendString('&promotionCode=' + this.tourCriteria.promotionCode,
            this.visibilityConfig['tour.search_tour_criteria.promo_code'] && !!this.tourCriteria.promotionCode)
          .appendString('&resort=' + this.tourCriteria.resort,
            this.visibilityConfig['tour.search_tour_criteria.resort'] && !!this.tourCriteria.resort)
          .appendString('&guideLanguage=' + this.tourCriteria.guideLanguage,
            this.visibilityConfig['tour.search_tour_criteria.guide_language'] && !!this.tourCriteria.guideLanguage)
          .appendString('&dateOffset=' + this.tourCriteria.dateOffset,
            this.visibilityConfig['tour.search_tour_criteria.flexible_on_dates'] &&
            typeof this.tourCriteria.dateOffset === 'number').getString();

      returningQueryString += '&expand=all';

      if( this.ENABLE_B2B_SEARCH && returningQueryString.includes( '&attributes=' ) )
      {
        returningQueryString = returningQueryString.replace(/(&attributes=[^&]*)/, "$1,ENABLE_B2B_SEARCH~true");
      }
      else if( this.ENABLE_B2B_SEARCH )
      {
        returningQueryString += '&attributes=ENABLE_B2B_SEARCH~true';
      }

      return returningQueryString;
  }

  /**
   * set refine search attributes
   */
  private setRefineDate() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.setRefineDate');
    if (this.tourCriteria.startMonth && this.tourCriteria.startYear) {
      const month = this.tourCriteria.startMonth;
      const year = this.tourCriteria.startYear;
      this.initialDates = [this.createDummyDateUsingMonthAndYear(year, month)];
      this.defaultActiveCalendar = CALENDAR_VIEW.SINGLE_MONTH_VIEW;
    } else if (this.tourCriteria.startYear) {
      const year = this.tourCriteria.startYear;
      this.initialDates = [this.createDummyDateUsingYear(year)];
      this.defaultActiveCalendar = CALENDAR_VIEW.SINGLE_YEAR_VIEW;
    } else if (this.tourCriteria && this.tourCriteria.startDate) {
      this.initialDates = [this.surfUtilService.getDateFromString(this.tourCriteria.startDate)];
      this.defaultActiveCalendar = CALENDAR_VIEW.SINGLE_DATE_VIEW;
    }
    if (this.tourCriteria && this.tourCriteria.startDate) {
      this.travellerEarliestDepartureDateService
          .setEarliestDepartureDateFromComponentCriteriaForNewlyAddedItem(this.tourCriteria.startDate);
      if (this.isAmendmentFlow) {
        this.doCheckLastMinuteBookingDate(true);
      }
    }
  }

  /**
   * create dummy date to set moth date picker
   */
  createDummyDateUsingMonthAndYear(year, month) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.createDummyDateUsingMonthAndYear');
    if (year && month && year > 0 && month > 0) {
      return new Date(year, month - 1, 1);
    }
    return new Date();
  }

  /**
   * create dummy date to set year date picker
   */
  createDummyDateUsingYear(year) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.createDummyDateUsingYear');
    if (year && year > 0) {
      return new Date(year, 0, 1);
    }
    return new Date();
  }

  convertStrToDateObj(str) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.convertStrToDateObj');
    if (str) {
      const dates = str.split('-');
      const  formattedDate = new Date(dates[0], dates[1] - 1, dates[2]);
      return formattedDate;
    }
    return  '';
  }

  tourGrabResultOutput(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.tourGrabResultOutput');
    if (event && event[0]) {
      this.grabbedTourId = '';
      this.stopSearchInitialized = false;
      this.destSearchInitiated = false;
      this.nameSearchInitialized = false;
      this.categorySearchInitialized = false;
      this.defaultPaxSet = [];
      this.resetDuration();
      this.resetDestination();
      this.resetStops();
      this.resetCategory();
      this.resetTourSupplier();
      this.resetTourName();
      this.isGrabbed = true;
      if (event[0].grabbedTourId) {
        this.grabbedTourId = event[0].grabbedTourId;
      }
      if (event[0].sourceInfo) {
        this.tourCriteria.sourceInfo = event[0].sourceInfo;
      }
    }
    this.displayingGrabbedTourDetailList = event;
    if (this.displayingGrabbedTourDetailList && this.displayingGrabbedTourDetailList.length > 0) {
      this.displayingGrabbedTourDetailList.forEach(item => {
        if (item && item.durationRange) {
          item.durationValue = this.getNewDurationValue(item.durationRange);
        }
        item.isOpenToShow = true;
      });
    }
    console.log(event);
    console.log(this.tourCriteria);
  }
  removeIfBlockedGrabbedResult(grabTourItem) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.removeIfBlockedGrabbedResult');
    if (grabTourItem.isBlockedResult) {
      grabTourItem.isOpenToShow = false;
    }
    if (this.displayingGrabbedTourDetailList && this.displayingGrabbedTourDetailList.length ===
      this.displayingGrabbedTourDetailList.filter(result => result && result.isOpenToShow === false).length) {
      this.isGrabbed = false;
      this.resetDisplayItems();
    }
  }

  /**
   * handle freeze-unfreeze checkbox
   */
  checkValue(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.checkValue');
    this.unfreeze = event.target.checked;
    this.freeze = !this.unfreeze;
    this.isUnfreeze.emit(event.target.checked);
  }

  doCheckLastMinuteBookingDate(isAmendmentOldItemDateSelection: boolean) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.doCheckLastMinuteBookingDate');
    const checkingDate = new Date(this.tourCriteria.startDate);
    if (this.surfCalendarStartDateService.validateWithCheckingIsEarlierDate(new Date(), checkingDate, 'TOU')) {
      this.hideErrorMsg = true;
      this.validateDisabledDateSelection = false;
      this.surfCalendarStartDateService.lastMinuteBookingErrorSet.delete(this.index);
      if (isAmendmentOldItemDateSelection) {
        this.surfCalendarStartDateService.hasValidUnfreezeItem = true;
      }
    } else {
      if (isAmendmentOldItemDateSelection) {
        this.surfCalendarStartDateService.hasValidUnfreezeItem = false;
      }
      this.surfCalendarStartDateService.lastMinuteBookingErrorSet.add(this.index);
      this.hideErrorMsg = false;
      this.validateDisabledDateSelection = true;
    }
  }

  setPromoCode(value: string) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.setPromoCode');
    if (value && value !== '') {
      this.tourCriteria.promotionCode = value;
    } else {
      this.tourCriteria.promotionCode = '';
    }
  }

  setResort(value: string) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.setResort');
    if (value && value !== '') {
      this.tourCriteria.resort = value;
    } else {
      this.tourCriteria.resort = '';
    }
  }

  setShowAdvancedSearch(value: boolean) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.setShowAdvancedSearch');
    if (typeof value === 'boolean') {
      this.showAdvancedSearch = value;
    }
  }

  selectPrivateTour(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.selectPrivateTour');
    if (event && typeof event.selected === 'boolean') {
      this.tourCriteria.privateTour = event.selected;
    }
  }

  selectFlexibleDate(event, isForced = false) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.selectFlexibleDate');
    event.code = typeof event.code === 'number' ? event.code : Number(event.code);
    if (!isForced) {
      this.tourCriteria.dateOffset = event.code;
    } else {
      this.flexibleOnDates.forEach(line => {
        if (event.code !== '') {
          if (event.code === line.code) {
            line.selected = true;
            if (this.tourCriteria) {
              this.tourCriteria.dateOffset = event.code;
            }
          } else {
            line.selected = false;
          }
        } else {
          line.selected = false;
          if (this.tourCriteria) {
            this.tourCriteria.dateOffset = null;
          }
        }
      });
      this.flexibleOnDates = JSON.parse(JSON.stringify(this.flexibleOnDates));
    }
  }

  selectGuideLang(event, isForced = false) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tour-criteria/src/lib/tour-criteria/tour-criteria.component.ts.TourCriteriaComponent.selectGuideLang');
    if (!isForced) {
      this.tourCriteria.guideLanguage = event.code;
    } else {
      this.guideLanguages.forEach(line => {
        if (event.code !== '') {
          if (event.code === line.code) {
            line.selected = true;
            if (this.tourCriteria) {
              this.tourCriteria.guideLanguage = event.code;
            }
          } else {
            line.selected = false;
          }
        } else {
          line.selected = false;
          if (this.tourCriteria) {
            this.tourCriteria.guideLanguage = null;
          }
        }
      });
      this.guideLanguages = JSON.parse(JSON.stringify(this.guideLanguages));
    }
  }
}
